import React from 'react'
import { Gauge } from '@mui/x-charts'
import { Flex } from 'antd'
import { t } from 'i18next'
import Title from 'antd/es/typography/Title'

export default function PostalPlaceFilledChart ({ appointments }) {
  const appointmentsWithPostalPlaces = appointments.filter((s) => s.postal_place_id)

  return (
    <Flex vertical align='center'>
      <Title level={5}>
        {t('Admin.Statistics.PostalPlaceFilledChart.title')}
      </Title>
      { appointments.length > 0 &&
        <Gauge width={150} height={100} startAngle={-110} endAngle={110}
          value={appointmentsWithPostalPlaces.length} valueMin={0} valueMax={appointments.length}
          text={({ value, valueMax }) => `${value} / ${valueMax}`}
        />
      }
      { appointments.length === 0 &&
        <Gauge width={150} height={100} startAngle={-110} endAngle={110}
          value={appointmentsWithPostalPlaces.length}
          text={() => '0 / 0'}
        />
      }
    </Flex>
  )
}
